import { Pipe, PipeTransform } from '@angular/core';
import { CommonService } from '../services/common.service';

@Pipe({
  name: 'UserSlug',
})
export class UserSlugPipe implements PipeTransform {
  constructor(private _common: CommonService) {}
  transform(user: any, id?: any): unknown {
    let user_id = '';
    if (!this._common.isBrowser) {
      user_id = Buffer.from((user.user_id || user.id).toString()).toString(
        'base64'
      );
    } else {
      user_id = btoa(id || user.user_id || user.id);
    }
    return (
      (user.username || user.user_name || user.name || '')
        ?.toLowerCase()
        .replace(new RegExp(' ', 'g'), '-') +
      '-' +
      user_id
    );
  }
}
